module.exports = __webpack_public_path__ + "static/media/thumb_WHT30_503x503.e71d4d61.jpg";